<template>
	<main role="main" class="container">
	   <div class="row">
	      <div class="col-md-12 ">
	         <h3 class="pb-3 mt-4 mb-4 border-bottom">Privacy Policy</h3>
	         <div>
	            <p>You share content on the site at your own risk. Although Haiwai.com Platforms may allow you to set privacy options that limit access to your information, please be aware that no security measures are perfect or impenetrable. Further, Haiwai.com cannot control the actions of other Users with whom you share your profile and information. Therefore, the Haiwai.com does not guarantee that User Content you post on the site will not be used improperly or viewed by other individuals.</p>
	            <h3>Security</h3>
	            <p>Participation in this Haiwai.com platform is voluntary. You accept responsibility for maintaining the confidentiality of your login information, and for all activities that occur under your login. You should immediately notify the platform of any unauthorized use of your login or account or any other breach of security. You agree that the Haiwai is not liable in any way for any loss or damage arising from your failure to comply with this Section.</p>
	            <ol></ol>
             <h3>Third-Party Services</h3>
             <p>Haiwai may share information that it collects from you, such as your email address (in hashed form), IP address or information about your browser or operating system, with its identity partners/service providers, including LiveRamp Inc. LiveRamp returns an online identification code that may be stored in Haiwai's first-party cookie for its use in online, in-app, and cross-channel advertising and it may be shared with advertising companies to enable interest-based and targeted advertising. To opt out of this use, please visit
               <a href="https://optout.liveramp.com/opt_out" class="text-black">https://optout.liveramp.com/opt_out.</a>
             </p>
	         </div>
	      </div>
	   </div>
	</main>
</template>
<script>

export default {
  name: 'privacy',
  components: {
    
  }
};
</script>
<style>
footer{
        /*position: fixed;*/
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1030;
}
</style>
